import { FixedSizeList as List } from "react-window";
import {
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
	CommandDialog,
} from "@lab/src/components/ui/command";

import { SetStateAction, useMemo, useState } from "react";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { getGuarantorDisplayName } from "../../../../lib/utils/guarantor-utils";

export const GuarantorCommandDialog: React.FC<{
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	onGuarantorSelect: (guarantorId: string) => void;
}> = ({ open, setOpen, onGuarantorSelect }) => {
	const { guarantorLookup } = useCentralStore((state) => ({
		guarantorLookup: state.guarantorLookup,
	}));

	if (!guarantorLookup || Object.keys(guarantorLookup).length === 0) {
		return null;
	}

	const [searchTerm, setSearchTerm] = useState("");

	const filteredGuarantors = useMemo(() => {
		const allGuarantors = Object.values(guarantorLookup);
		if (!searchTerm) {
			return allGuarantors;
		}
		const lowerSearchTerm = searchTerm.toLowerCase();
		return allGuarantors.filter((guarantor) => {
			const displayName = getGuarantorDisplayName(guarantor).toLowerCase();
			return displayName.includes(lowerSearchTerm);
		});
	}, [guarantorLookup, searchTerm]);

	const handleDialogOpenChange = (open: boolean) => {
		setOpen(open);
		if (!open) {
			setSearchTerm("");
		}
	};

	return (
		<CommandDialog open={open} onOpenChange={handleDialogOpenChange}>
			<CommandInput
				noListSearch
				placeholder="Kostenträger suchen…"
				value={searchTerm}
				onValueChange={setSearchTerm}
			/>
			<CommandList className="h-96 max-h-96">
				<CommandGroup className="w-[500px]">
					<List
						height={324}
						itemCount={filteredGuarantors.length}
						itemSize={50}
						width="100%"
					>
						{({ index, style }) => {
							const guarantor = filteredGuarantors[index];
							const guarantorId = guarantor?.id;
							const name = getGuarantorDisplayName(guarantor);
							return (
								<CommandItem
									key={guarantorId}
									className="flex cursor-pointer w-full h-full flex-row gap-2 items-center"
									style={style}
									onSelect={() => {
										onGuarantorSelect(guarantorId);
										setOpen(false);
									}}
								>
									<div className="text-lg">{name}</div>
									<div className="text-gray-500">
										{guarantor.code}
									</div>
								</CommandItem>
							);
						}}
					</List>
				</CommandGroup>
			</CommandList>
		</CommandDialog>
	);
};
